import { useState } from 'react';

export const useFilters = (initialFilters = {}) => {
  const [filters, setFilters] = useState({
    searchTerm: '',
    bdName: '',
    status: '',
    sortBy: 'maxRound', // Default sort by maximum round
    ...initialFilters
  });

  const updateFilter = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const clearFilters = () => {
    setFilters({
      searchTerm: '',
      bdName: '',
      status: '',
      sortBy: 'maxRound' // Keep default sort
    });
  };

  const hasActiveFilters = () => {
    return Object.values(filters).some(value => value !== '');
  };

  return {
    filters,
    updateFilter,
    clearFilters,
    hasActiveFilters
  };
};